import { render, staticRenderFns } from "./statistics-box.vue?vue&type=template&id=596136e3"
import script from "./statistics-box.vue?vue&type=script&lang=ts"
export * from "./statistics-box.vue?vue&type=script&lang=ts"
import style0 from "./statistics-box.vue?vue&type=style&index=0&id=596136e3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports